(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/login-iam/assets/javascripts/react/login-iam.js') >= 0) return;  svs.modules.push('/modules/login-iam/assets/javascripts/react/login-iam.js');

'use strict';

const CorpInfo = svs.login_iam.CorpInfo;
const BrandCubes = svs.accountservices_react.brand_cubes.BrandCubes;
const LoginIam = () => {
  var _svs;
  const _svs$login_iam$data = svs.login_iam.data,
    isTestEnvironment = _svs$login_iam$data.isTestEnvironment,
    iamIframeUrl = _svs$login_iam$data.iamIframeUrl,
    fraudInformationLink = _svs$login_iam$data.fraudInformationLink,
    showFraudInformationLink = _svs$login_iam$data.showFraudInformationLink;
  const isMobile = svs.core.detect.formfactor.mobile();
  const isMomang = ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.svsconfig) === null || _svs === void 0 || (_svs = _svs.site) === null || _svs === void 0 ? void 0 : _svs.toLowerCase()) === 'momang';
  const cdn = svs.core.config.data.svsconfig.cdn;
  const iframeRef = React.useRef(null);
  return React.createElement(React.Fragment, null, React.createElement("img", {
    alt: "",
    className: "login-iam-ao-brand-divider",
    src: "".concat(cdn, "/images/components/ao-logotype-soc/ao-soc.svg"),
    tabIndex: 0
  }), React.createElement("div", {
    className: "".concat(isMomang ? 'fc-white ' : '', "align-center padding-top-2")
  }, React.createElement("h1", {
    className: "f-900 iamlogin-title"
  }, "V\xE4lkommen till", React.createElement("br", null), !isMomang && isMobile && 'Svenska Spel', !isMomang && !isMobile && 'Svenska Spel Sport & Casino', isMomang && 'Momang!', React.createElement("br", null), !isMomang && isMobile && 'Sport & Casino'), isMobile && React.createElement(CorpInfo, null)), React.createElement("div", {
    className: "iamlogin-container align-center padding-sm-top-1 padding-xl-top-2",
    role: "main"
  }, React.createElement(BrandCubes, null), React.createElement("iframe", {
    allow: "local-network-access",
    className: "iamlogin-iframe".concat(isTestEnvironment ? ' iamlogin-iframe-test-panel' : ''),
    id: "iamlogin-iframe",
    onLoad: () => {
      if (iframeRef.current) {
        iframeRef.current.classList.add('iamlogin-iframe-loaded');
      }
    },
    ref: iframeRef,
    sandbox: "allow-same-origin allow-scripts allow-forms allow-modals allow-popups",
    src: iamIframeUrl
  }), React.createElement("p", {
    className: "".concat(isMomang ? 'fc-white ' : '', "padding-top-1")
  }, !isMobile && 'Vid inloggning kontrolleras din identitet, att du är över 18 år', isMobile && 'Vid inloggning kontrolleras din identitet, att du', ' ', React.createElement("br", null), ' ', isMobile && 'är över 18 år och folkbokförd i Sverige.', !isMobile && ' och folkbokförd i Sverige.'), showFraudInformationLink && React.createElement("a", {
    className: "u-text-decoration-underline ".concat(isMomang ? 'fc-white ' : 'fc-sport-75'),
    href: fraudInformationLink,
    rel: "noreferrer",
    target: "_blank"
  }, "L\xE4s mer om hur du loggar in s\xE4kert"), !isMobile && React.createElement(CorpInfo, null)));
};
svs.login_iam.LoginIam = LoginIam;

 })(window);